import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component StickyIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <StickyIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <StickyIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const StickyIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="StickyIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M3 6.95a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v6.087a4 4 0 0 1-1.161 2.819l-3.884 3.912a4 4 0 0 1-2.84 1.182H7a4 4 0 0 1-4-4z"
        style={{
          fill: "#ffcc6b",
        }}
      />
      <path
        d="M17.031 13.95h2a2 2 0 0 0 1.992-1.818l.008-2.651v2.469q0 .092-.008.182l-.003.866a4 4 0 0 1-1.144 2.789L15.99 19.75a4 4 0 0 1-2.856 1.2H12.03a2 2 0 0 0 2-2v-2a3 3 0 0 1 3.001-3"
        style={{
          fill: "#c49cb6",
        }}
      />
    </svg>
  )
);
StickyIcon.displayName = "StickyIcon";
export default StickyIcon;
